/**
 * Games Year Filter Component
 * Handles form submission for games year/period filtering
 * Redirects to /pages/games-YYYY or /pages/games-YYYY-YYYY for past periods
 */

class GamesYearFilter extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.select = this.querySelector('select');

    if (this.form && this.select) {
      this.init();
    }
  }

  getBasePageUrl() {
    const pageUrl = this.dataset.blogUrl || window.location.pathname;
    const match = pageUrl.match(/^(\/pages)(?:\/(?:en-)?games(?:-\d{4}(?:-\d{4})?)?)?/);
    if (match) {
      return match[1];
    }
    return '/pages';
  }

  isEnglishPage() {
    const pageUrl = this.dataset.blogUrl || window.location.pathname;
    return pageUrl.includes('en-games') || pageUrl.includes('/en');
  }

  getActivePeriod() {
    const startYear = this.dataset.activeYear || '';
    const endYear = this.dataset.activeYearEnd || startYear;
    return { startYear, endYear };
  }

  parsePeriodValue(value) {
    if (!value) {
      return null;
    }

    if (value.includes('|')) {
      const [startYear, endYear] = value.split('|');
      return {
        startYear: startYear.trim(),
        endYear: (endYear || startYear).trim(),
      };
    }

    const trimmed = value.trim();
    return {
      startYear: trimmed,
      endYear: trimmed,
    };
  }

  buildPageHandle(prefix, startYear, endYear) {
    if (endYear && endYear !== startYear) {
      const shortEnd = endYear.length === 4 ? endYear.slice(-2) : endYear;
      return `${prefix}-${startYear}-${shortEnd}`;
    }
    return `${prefix}-${startYear}`;
  }

  isSamePeriod(a, b) {
    return a.startYear === b.startYear && a.endYear === b.endYear;
  }

  redirectToPeriod(period) {
    const isEn = this.isEnglishPage();
    const prefix = isEn ? 'en-games' : 'games';
    const baseUrl = this.getBasePageUrl();
    const activePeriod = this.getActivePeriod();

    if (this.isSamePeriod(period, activePeriod)) {
      window.location.href = isEn ? '/pages/en-games' : '/pages/games';
      return;
    }

    const handle = this.buildPageHandle(prefix, period.startYear, period.endYear);
    window.location.href = `${baseUrl}/${handle}`;
  }

  init() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();

      const selectedValue = this.select.value;
      if (!selectedValue) {
        const isEn = this.isEnglishPage();
        window.location.href = isEn ? '/pages/en-games' : '/pages/games';
        return;
      }

      const period = this.parsePeriodValue(selectedValue);
      if (!period) {
        return;
      }

      this.redirectToPeriod(period);
    });
  }
}

if (!customElements.get('games-year-filter')) {
  customElements.define('games-year-filter', GamesYearFilter);
}

document.addEventListener('DOMContentLoaded', () => {
  const gamesYearFilters = document.querySelectorAll('.games-year-filter');

  gamesYearFilters.forEach((filter) => {
    const form = filter.querySelector('form');
    const select = filter.querySelector('select');

    if (!form || !select) return;

    const getBasePageUrl = () => {
      const pageUrl = filter.dataset.blogUrl || window.location.pathname;
      const match = pageUrl.match(/^(\/pages)(?:\/(?:en-)?games(?:-\d{4}(?:-\d{4})?)?)?/);
      return match ? match[1] : '/pages';
    };

    const isEnglishPage = () => {
      const pageUrl = filter.dataset.blogUrl || window.location.pathname;
      return pageUrl.includes('en-games') || pageUrl.includes('/en');
    };

    const getActivePeriod = () => {
      const startYear = filter.dataset.activeYear || '';
      const endYear = filter.dataset.activeYearEnd || startYear;
      return { startYear, endYear };
    };

    const parsePeriodValue = (value) => {
      if (!value) return null;
      if (value.includes('|')) {
        const [startYear, endYear] = value.split('|');
        return {
          startYear: startYear.trim(),
          endYear: (endYear || startYear).trim(),
        };
      }
      const trimmed = value.trim();
      return { startYear: trimmed, endYear: trimmed };
    };

    const buildPageHandle = (prefix, startYear, endYear) => {
      if (endYear && endYear !== startYear) {
        const shortEnd = endYear.length === 4 ? endYear.slice(-2) : endYear;
        return `${prefix}-${startYear}-${shortEnd}`;
      }
      return `${prefix}-${startYear}`;
    };

    const isSamePeriod = (a, b) =>
      a.startYear === b.startYear && a.endYear === b.endYear;

    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const selectedValue = select.value;
      const isEn = isEnglishPage();

      if (!selectedValue) {
        window.location.href = isEn ? '/pages/en-games' : '/pages/games';
        return;
      }

      const period = parsePeriodValue(selectedValue);
      if (!period) return;

      const prefix = isEn ? 'en-games' : 'games';
      const baseUrl = getBasePageUrl();
      const activePeriod = getActivePeriod();

      if (isSamePeriod(period, activePeriod)) {
        window.location.href = isEn ? '/pages/en-games' : '/pages/games';
        return;
      }

      const handle = buildPageHandle(prefix, period.startYear, period.endYear);
      window.location.href = `${baseUrl}/${handle}`;
    });
  });
});
